import { ReactNode } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { ExpanderStack } from "@/components/adg4/price-card/src/index.ts";
import { PlanFeatureMessage } from "@/components/wpl/pricing/src/price-finder/constants.tsx";
import { PlanFeature } from "@/components/wpl/pricing/src/price-finder/price-card/price-card-plan-feature.tsx";

export interface FeaturesSectionProps {
    planFeatureMessages?: PlanFeatureMessage[];
    highlightedFeaturesTitle: ReactNode;
}

export const FeaturesSection = ({
    planFeatureMessages = [],
    highlightedFeaturesTitle
}: FeaturesSectionProps) => {
    return (
        <section css={featuresSectionStyles}>
            <ExpanderStack heading={highlightedFeaturesTitle}>
                <ul css={planFeatureMessageContainerStyles}>
                    {planFeatureMessages.map((planFeatureMessage, idx) => {
                        return (
                            <li key={idx} css={planFeatureMessagesStyles}>
                                <PlanFeature
                                    {...planFeatureMessage}
                                    padded={false}
                                />
                            </li>
                        );
                    })}
                </ul>
            </ExpanderStack>
        </section>
    );
};

const planFeatureMessageContainerStyles = css({
    padding: "0",
    marginBlockStart: "0",
    listStyleType: "none"
});
const planFeatureMessagesStyles = css({
    "marginBlockStart": "16px",
    "&:nth-of-type(1)": {
        marginBlockStart: "0px"
    }
});
const featuresSectionStyles = css({
    paddingBlockEnd: token("space.300"),
    paddingInlineStart: token("space.500"),
    paddingInlineEnd: token("space.500")
});
